import React from 'react';
import { CircleCheck } from 'lucide-react';
import { Button } from 'shared-portal-components-v2';

import '@/components/organism/style.scss';

interface RegistrationSuccessProps {
  onContinue: () => void;
  title?: string;
  body?: string;
  buttonLabel?: string;
}

const DEFAULT_TITLE = 'Welcome to PortalSIX!';
const DEFAULT_BODY =
  'Your account is now set up and ready to use. You can start collaborating securely with your team right away.';
const DEFAULT_BUTTON_LABEL = 'Get Started';

const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({
  onContinue,
  title = DEFAULT_TITLE,
  body = DEFAULT_BODY,
  buttonLabel = DEFAULT_BUTTON_LABEL,
}) => (
  <div className="w-full max-w-md flex flex-col gap-8">
    <div className="text-center flex flex-col gap-6 justify-center">
      <div>
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4">
          <CircleCheck className="w-10 h-10 text-green-600" aria-hidden="true" />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-foreground">{title}</h1>
        <p className="text-muted-foreground text-lg">{body}</p>
      </div>

      <Button
        type="button"
        variant="primary"
        size="lg"
        className="w-full h-12 text-base font-semibold"
        onClick={onContinue}
      >
        {buttonLabel}
      </Button>
    </div>
  </div>
);

export default RegistrationSuccess;
